import { RootState } from '@app/redux/root-reducer';

export const selectGetOverdueTasksState = (store: RootState) =>
  store.overdueTasksReducer.overdueTasks;
